export default __webpack_public_path__ + "380a411a373466b8f51a24e50323f70c.png";